/**
 * Deterministic history transaction id for a command over a set of objects: the command prefix
 * plus the ids, sorted, so the same set always yields the same id whatever order it was read in.
 */
export function buildSortedIdsTxnId(prefix: string, ids: readonly string[]): string {
  return `${prefix}:${ids.slice().sort().join('|')}`
}
